module.exports = __webpack_public_path__ + "static/media/BellDot.7a59d00c.svg";